import { combineReducers } from 'redux';
import achievements from './achievements';
import appOrganization from './appOrganization';
import attachments from './attachments';
import chat from './bot';
import categories from './category';
import categoryManagement from './categoryManagement';
import classifications from './classification';
import common from './common';
import evaluationQuestion from './evaluationQuestion';
import favorite from './favorite';
import followers from './followers';
import header from './header';
import highlights from './highlights';
import identity from './identity';
import itens from './item';
import learningMap from './learningMap';
import lessons from './lesson';
import lists from './list';
import listItems from './listItems';
import locale from './locale';
import onboard from './onboard';
import people from './person';
import program from './program';
import programClass from './programClass';
import pushNotification from './pushNotification';
import questionnaire from './questionnaire';
import quiz from './quiz';
import rating from './rating';
import report from './report';
import saml from './saml';
import scorm from './scorm';
import search from './search';
import student from './student';
import tags from './tag';
import users from './user';

export default combineReducers({
    appOrganization,
    categories,
    categoryManagement,
    identity,
    locale,
    itens,
    lists,
    tags,
    users,
    people,
    attachments,
    favorite,
    listItems,
    rating,
    classifications,
    highlights,
    search,
    pushNotification,
    lessons,
    common,
    programClass,
    header,
    questionnaire,
    evaluationQuestion,
    scorm,
    program,
    onboard,
    quiz,
    learningMap,
    chat,
    followers,
    report,
    student,
    achievements,
    saml,
});
